import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../toast/toast.component';
import { RecordService } from '../../../services/record.service';
import { Client } from '../../models/client.model';
import { Record } from '../../models/record.model';
import { ee, activities, statuses, formats, feedbacks, dateRegexp, urlRegexp } from '../../constants';
import { generateListItem, setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-record-modal',
  templateUrl: './edit-record-modal.component.html',
  standalone: false
})
export class EditRecordModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private recordService = inject(RecordService);


  @Input() clients: Client[] = [];
  @Input() record: Record = {};

  activities = activities;
  statuses = statuses;
  formats = formats;
  feedbacks = feedbacks;
  dateRegexp = dateRegexp;
  urlRegexp = urlRegexp;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditRecordModal', (record: Record) => this.record = record);
    // This initializes the date in the select with the current value
    this.record.date = (this.record.date as string)?.substring(0, 10);
  }

  ngOnDestroy(): void {
    ee.off('showEditRecordModal', () => {});
  }

  isModalInvalid(): boolean {
    return !this.record._clients.length ||
      (this.record.activity === 'UTOPIA Studios - URANIA' && (!this.record.moderator || !this.record.format)) ||
      (this.record.followup === 'yes' && !this.record.followupnotes);
  }

  addListItem(type: string): void {
    const listItem = generateListItem(type);
    this.record.notes += listItem;
  }

  updateRecord(record: Record): void {
    const update = {
      ...record,
      // Prevent Request Entity Too Large / Payload Too Large caused by these fields that are populated
      _user: record._user._id,
      _clients: record._clients.map(client => client._id),
      _politicians: record._politicians.map(politician => politician._id),
      _users: record._users.map(user => user._id),
      _organizations: record._organizations.map(organization => organization._id),
      timesheet: record.timesheet.map(time => ({ ...time, _user: time._user._id })),
    };
    this.recordService.update(update)
      .pipe(finalize(() => {
        ee.emit('getRecords');
        ee.emit('getRecord');
      }))
      .subscribe({
        next: res => this.toast.setMessage('Record updated successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
